import { AxiosResponse } from 'axios';
import { ActDomainFormVM } from 'civil-status/view-models/act-domain-form';
import { ActDomainManagement } from 'shell/models/act-domain-management';
import { HttpResponse } from 'shell/models/http-response';

export const transformActDomain = (
  response: AxiosResponse<HttpResponse<ActDomainManagement>>
): ActDomainFormVM => {
  const data: ActDomainManagement = response?.data?.payload || {};
  const res: ActDomainFormVM = {
    domainName: data?.nomeDominio || '',
    domainType: data?.key?.idDominio?.toString() || '',
    usageNote: data?.noteUtilizzo || '',
    entityBody: data?.key?.codEnte || '',
  };
  return res;
};
